import { useMutation, useQuery } from "@tanstack/react-query";
import {
  sendDocumentEmail,
  getDocumentWhatsAppRecipients,
  uploadDocument,
  checkDocument,
  deleteDocument,
} from "services/document";

export const useSendDocumentEmail = () => {
  return useMutation({
    mutationFn: (data) => sendDocumentEmail(data),
  });
};

export const useGetDocumentWhatsAppRecipients = () => {
  return useMutation({
    mutationFn: (data) => getDocumentWhatsAppRecipients(data),
  });
};

export const useUploadDocument = () => {
  return useMutation({
    mutationFn: ({ file, filename }) => uploadDocument(file, filename),
  });
};

export const useCheckDocument = (filename, enabled = true) => {
  return useQuery({
    queryKey: ["doc-check", filename],
    queryFn: () => checkDocument(filename),
    enabled: Boolean(filename) && enabled,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
};

export const useDeleteDocument = () => {
  return useMutation({
    mutationFn: (filename) => deleteDocument(filename),
  });
};

